import api from "../../../api";

const API_URL = "/crm/format-numbers";

export async function getFormatNumbers() {
  const res = await api.get(API_URL);
  return res.data;
}

export async function getFormatNumber(id) {
  const res = await api.get(`${API_URL}/${id}`);
  return res.data;
}

export async function createFormatNumber(data) {
  console.log('Sending data to backend:', data);
  const res = await api.post(API_URL, data, {
    headers: {
      'Content-Type': 'application/json',
    },
  });
  return res.data;
}

export async function updateFormatNumber(id, data) {
  const res = await api.put(`${API_URL}/${id}`, data, {
    headers: {
      'Content-Type': 'application/json',
    },
  });
  return res.data;
}

export async function deleteFormatNumber(id) {
  return api.delete(`${API_URL}/${id}`);
} 